<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">
        <div class="emd-section fade-in">
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
          <div v-else class="emd-box fade-in">
            <EmdBoxHeader :title="$t('edit.form.callbacks.development')">
              <button class="emd-btn _color_secondary _type_text" v-show="disabled.dev" @click="disabled.dev = !disabled.dev">{{$t('edit.edit')}}</button>
            </EmdBoxHeader>
            <div class="emd-box__content">
              <div class="emd-alert _color_success hideFeedback" ref="feedbackdev">
                <p>{{$t('edit.form.callbacks.success_message')}}</p>
              </div>
              <div v-if="errors['dev'].length > 0">
                <error-list :items="errors['dev']" v-show="!disabled.dev"></error-list>
              </div>
              <form action="javascript:void(0)" ref="formCallbacksDev" @submit.prevent="saveCallbacks($event, 'dev')" novalidate="true">
                <fieldset>
                  <div class="emd-flex _direction_column _direction_row_md">
                    <div class="emd-flex-item _basis_12 _basis_6_md">
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="callbackUrl">{{$t('edit.form.callbacks.webhooksURL')}}:
                          </label>
                          <input @focus="sendFsEvent('url-dev-eventos')" class="emd-input" id="callbackUrl" type="url" :disabled="disabled.dev" v-model="webhooksDevelopUrl">
                        </div>
                      </div>
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="callbackInstall">{{$t('edit.form.callbacks.hubURL')}}:
                          </label>
                          <input @focus="sendFsEvent('url-dev-instal')"  class="emd-input" id="callbackInstall" type="url" :disabled="disabled.dev" v-model="hubCallbackDevelopUrl">
                        </div>
                      </div>
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="callbackValidation">{{$t('edit.form.callbacks.validationURL')}}:
                          </label>
                          <input @focus="sendFsEvent('url-dev-dados-adicionais')" class="emd-input" id="callbackValidation" type="url" :disabled="disabled.dev" v-model="validationCallbackDevelopUrl">
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <div class="emd-flex _justify_flex-end" v-show="!disabled.dev">
                    <div class="emd-flex-item _shrink">
                      <button class="emd-btn _color_primary _type_text" type="button" @click="disabled.dev = !disabled.dev">{{$t('edit.cancel')}}</button>
                    </div>
                    <div class="emd-flex-item _shrink">
                      <button class="emd-btn _color_secondary" type="submit" :disabled="!formIsValid.dev">{{$t('edit.save')}}</button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>

        <div class="emd-section fade-in">
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center"></p>
          <div v-else class="emd-box fade-in">
            <EmdBoxHeader :title="$t('edit.form.callbacks.production')">
              <button class="emd-btn _color_secondary _type_text" v-show="disabled.prod" @click="disabled.prod = !disabled.prod">{{$t('edit.edit')}}</button>
            </EmdBoxHeader>
            <div class="emd-box__content">
              <div class="emd-alert _color_success hideFeedback" ref="feedbackprod">
                <p>{{$t('edit.form.callbacks.success_message')}}</p>
              </div>
              <div v-if="errors['prod'].length > 0">
                <error-list :items="errors['prod']" v-show="!disabled.prod"></error-list>
              </div>
              <form action="javascript:void(0)" ref="formCallbacksProd" @submit.prevent="saveCallbacks($event, 'prod')" novalidate="true">
                <fieldset>
                  <div class="emd-flex _direction_column _direction_row_md">
                    <div class="emd-flex-item _basis_12 _basis_6_md">
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="callbackUrlPrd">{{$t('edit.form.callbacks.webhooksURL')}}:</label>
                          <input @focus="sendFsEvent('url-prod-eventos')" class="emd-input" id="callbackUrlPrd" type="url" :disabled="disabled.prod" v-model="webhooksUrl" v-on:focusout="form.validateInput">
                        </div>
                      </div>
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="callbackInstallPrd">{{$t('edit.form.callbacks.hubURL')}}:</label>
                          <input @focus="sendFsEvent('url-prod-instal')"  class="emd-input" id="callbackInstallPrd" type="url" :disabled="disabled.prod" v-model="hubCallbackUrl" v-on:focusout="form.validateInput">
                        </div>
                      </div>
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="callbackValidationPrd">{{$t('edit.form.callbacks.validationURL')}}:</label>
                          <input @focus="sendFsEvent('url-prod-dados-adicionais')" class="emd-input" id="callbackValidationPrd" type="url" :disabled="disabled.prod" v-model="validationCallbackUrl" v-on:focusout="form.validateInput">
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <div class="emd-flex _justify_flex-end" v-show="!disabled.prod">
                    <div class="emd-flex-item _shrink">
                      <button class="emd-btn _color_primary _type_text" type="button" @click="disabled.prod = !disabled.prod">{{$t('edit.cancel')}}</button>
                    </div>
                    <div class="emd-flex-item _shrink">
                      <button class="emd-btn _color_secondary" type="submit" :disabled="!formIsValid.prod">{{$t('edit.save')}}</button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorList from '@/components/project/ErrorList.vue'
import EmdBoxHeader from '@/components/emerald/EmdBoxHeader'
import form from '@/plugins/form.js'
import sendFsCustomEvent from '@/mixins/sendFsCustomEvent'

export default {
  name: 'ApplicationCallbacks',
  components: {
    ErrorList,
    EmdBoxHeader
  },
  mixins: [sendFsCustomEvent],
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    requestFailed () {
      return this.$store.state.application.detail.requestFailed
    },
    webhooksUrl: {
      get () {
        if (this.body.webhooks_url === undefined) {
          this.body.webhooks_url = this.$store.state.application.detail.webhooks_url
        }
        return this.body.webhooks_url
      },
      set (value) {
        if (this.disabled.prod) {
          this.body.webhooks_url = this.$store.state.application.detail.webhooks_url
        } else {
          this.body.webhooks_url = value
        }
      }
    },
    webhooksDevelopUrl: {
      get () {
        if (this.body.webhooks_develop_url === undefined) {
          this.body.webhooks_develop_url = this.$store.state.application.detail.webhooks_develop_url
        }
        return this.body.webhooks_develop_url
      },
      set (value) {
        if (this.disabled.dev) {
          this.body.webhooks_develop_url = this.$store.state.application.detail.webhooks_develop_url
        } else {
          this.body.webhooks_develop_url = value
        }
      }
    },
    validationCallbackUrl: {
      get () {
        if (this.body.validation_callback_url === undefined) {
          this.body.validation_callback_url = this.$store.state.application.detail.validation_callback_url
        }
        return this.body.validation_callback_url
      },
      set (value) {
        if (this.disabled.prod) {
          this.body.validation_callback_url = this.$store.state.application.detail.validation_callback_url
        } else {
          this.body.validation_callback_url = value
        }
      }
    },
    validationCallbackDevelopUrl: {
      get () {
        if (this.body.validation_callback_develop_url === undefined) {
          this.body.validation_callback_develop_url = this.$store.state.application.detail.validation_callback_develop_url
        }
        return this.body.validation_callback_develop_url
      },
      set (value) {
        if (this.disabled.dev) {
          this.body.validation_callback_develop_url = this.$store.state.application.detail.validation_callback_develop_url
        } else {
          this.body.validation_callback_develop_url = value
        }
      }
    },
    hubCallbackUrl: {
      get () {
        if (this.body.hub_callback_url === undefined) {
          this.body.hub_callback_url = this.$store.state.application.detail.hub_callback_url
        }
        return this.body.hub_callback_url
      },
      set (value) {
        if (this.disabled.prod) {
          this.body.hub_callback_url = this.$store.state.application.detail.hub_callback_url
        } else {
          this.body.hub_callback_url = value
        }
      }
    },
    hubCallbackDevelopUrl: {
      get () {
        if (this.body.hub_callback_develop_url === undefined) {
          this.body.hub_callback_develop_url = this.$store.state.application.detail.hub_callback_develop_url
        }
        return this.body.hub_callback_develop_url
      },
      set (value) {
        if (this.disabled.dev) {
          this.body.hub_callback_develop_url = this.$store.state.application.detail.hub_callback_develop_url
        } else {
          this.body.hub_callback_develop_url = value
        }
      }
    }
  },
  data () {
    return {
      disabled: {
        prod: true,
        dev: true
      },
      formIsValid: {
        prod: true,
        dev: true
      },
      body: {
        webhooks_url: undefined,
        webhooks_develop_url: undefined,
        validation_callback_url: undefined,
        validation_callback_develop_url: undefined,
        hub_callback_url: undefined,
        hub_callback_develop_url: undefined
      },
      errors: {
        prod: [],
        dev: []
      },
      form: form
    }
  },
  methods: {
    displayFeedback (env) {
      this.$refs[`feedback${env}`].classList.add('displayFeedback')
      this.$refs[`feedback${env}`].classList.remove('hideFeedback')
      setTimeout(() => {
        this.$refs[`feedback${env}`].classList.remove('displayFeedback')
        this.$refs[`feedback${env}`].classList.add('hideFeedback')
      }, 2000)
    },
    saveCallbacks (e, env) {
      const elements = [...e.target.elements]
      const invalidElements = elements.filter(element => element.willValidate).filter(element => !element.checkValidity())
      if (invalidElements.length === 0) {
        const submitButton = elements.filter(e => e.type === 'submit')[0]
        submitButton.classList.add('_state_loading')
        this.$store.dispatch('UPDATE_CALLBACKS', this.body)
          .then(response => {
            this.errors[env] = []
            this.disabled.dev = true
            this.disabled.prod = true
            this.displayFeedback(env)
            submitButton.classList.remove('_state_loading')
          })
          .catch(response => {
            submitButton.classList.remove('_state_loading')
            if (response.status === 400) {
              this.errors[env] = response.body.errors
            }
          })
      } else {
        invalidElements.forEach(element => {
          form.addInputError(element)
        })
      }
    }
  },
  updated () {
    this.formIsValid.dev = this.$refs.formCallbacksDev.checkValidity()
    this.formIsValid.prod = this.$refs.formCallbacksProd.checkValidity()
  }
}
</script>
<style scoped>
.emd-box._state_loading {
  height: 460px;
  background-repeat: no-repeat;
  background-image:
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4);
  background-size:
    260px 25px,
    190px 20px,
    96% 39px,
    190px 20px,
    96% 39px,
    190px 20px,
    96% 39px;
  background-position:
    2% 6%,
    1.75% 20%,
    24% 27.55%,
    1.75% 47%,
    24% 55.55%,
    1.75% 74%,
    24% 84%;
  opacity: 1;
  animation: opacity 1s infinite ease-in;
}
@media (min-width:768px) {
  .emd-box._state_loading {
    background-size:
      260px 25px,
      190px 20px,
      48% 39px,
      190px 20px,
      48% 39px,
      190px 20px,
      48% 39px;
    background-position:
      2% 6%,
      1.75% 20%,
      3% 27.55%,
      1.75% 47%,
      3% 55.55%,
      1.75% 74%,
      3% 84%;
  }
}

</style>
